import type { ActionAdapter } from "@adland/react/core";
import { makeAdlandSlot } from "./element";

/**
 * Define the `<adland-slot>` custom element bound to a click-routing adapter.
 * Safe to call more than once and in non-DOM environments — it no-ops if the
 * element is already defined or `customElements` is unavailable (SSR).
 */
export function registerAdlandSlot(
  adapter: ActionAdapter,
  tag = "adland-slot",
): void {
  if (typeof customElements === "undefined") return;
  if (customElements.get(tag)) return;
  customElements.define(tag, makeAdlandSlot(adapter));
}
